import React from 'react';
import { ExtendedContentContainer, ExtendedContentType } from 'components/ExtendedContent/ExtendedContentContainer';
import ZhuyinWord from 'components/ZhuyinWord';

export const ZhuyinWordModalComponent = ({ zhuyinWordResource }) => {
  return <ExtendedContentContainer extendedContentType={ExtendedContentType.ZhuyinWord}>
    <ZhuyinWord resource={zhuyinWordResource} />
  </ExtendedContentContainer>
};